import payments from '../../images/docs/main-menu-pay-edit.png';
import paymentElementExtra from '../../images/docs/payment-history-info-proform-edit.png';

export const meta = {
  slug: 'facturi-si-plati',
  title: 'Facturi și plăți',
  description: 'Vizualizarea istoricului de plăți și a facturilor aferente abonamentelor.',
  icon: 'file-invoice',
  order: 5,
  related: ['abonamente', 'cont'],
};

export const images = { payments, paymentElementExtra };

export const content = `
## Facturi și plăți

Pentru a verifica orice informație legată de facturi trebuie să fiți autentificat. Pentru a vizualiza întregul istoric de plăți împreună cu facturile aferente va trebui să intrați în meniul "Plăți" <span class="dot">1</span>

::image[payments]{alt="Butonul principal plăți"}

Din acest meniu puteți vizualiza informații despre fiecare factură, precum seria și numărul <span class="dot">2</span>, data emiterii <span class="dot">3</span>, starea facturii <span class="dot">4</span>, factura în format PDF <span class="dot">5</span> și meniul de acțiuni <span class="dot">6</span>

::image[paymentElementExtra]{alt="Detalii extinse factură"}

Meniul de acțiuni <span class="dot">6</span> are diferite opțiuni depinzând de starea facturii. Atunci când factura (proformă) este neachitată, meniul de acțiuni <span class="dot">6</span> afișează butoanele "Achită" și "Anulează". Odată ce factura este marcată ca și plătită, meniul de acțiuni <span class="dot">6</span> afișează butonul prin care puteți descărca factura în format PDF.

### Modalități de plată

Butonul "Achită" deschide o fereastră din care alegeți cum doriți să plătiți:

- **Plată cu cardul** - confirmați datele de facturare (inclusiv codul poștal, cerut de procesatorul de plăți), apoi sunteți redirecționat către pagina securizată **NETOPIA Payments**. Datele cardului se introduc exclusiv acolo; acestea nu trec și nu sunt stocate pe serverele noastre. Plata se face în Lei, la valoarea totală cu TVA afișată pe proformă, calculată la cursul BNR înregistrat pe factură. După confirmarea plății reveniți automat în aplicație, iar **abonamentul se activează singur**, în câteva secunde.
- **Transfer bancar** - se afișează IBAN-ul, banca, beneficiarul, CUI-ul, suma totală și detaliile plății (ID-ul comenzii). Abonamentul se activează **după confirmarea încasării**, de regulă în 1-2 zile lucrătoare. Pentru o activare mai rapidă ne puteți trimite dovada plății la [programintrastat@gmail.com](mailto:programintrastat@gmail.com).

<p class="warn">Dacă plata cu cardul nu reușește sau renunțați la ea, nu se reține nicio sumă de pe card. Comanda rămâne valabilă și o puteți achita ulterior, prin oricare dintre cele două metode.</p>

### Anularea unei comenzi neachitate

Cât timp aveți o factură proformă neachitată nu puteți comanda un alt abonament. Dacă v-ați răzgândit, apăsați butonul "Anulează" din dreptul comenzii. Comanda se anulează, abonamentul neactivat se dezactivează, iar abonamentul anterior - dacă mai este valabil - redevine activ. După aceea puteți alege din nou orice abonament.

### Plata nu s-a confirmat imediat

În cazuri rare confirmarea de la procesatorul de plăți poate întârzia. **Nu efectuați plata din nou.** Abonamentul se activează automat imediat ce primim confirmarea, iar dacă apare o problemă vă contactăm pe email. Starea comenzii poate fi urmărită oricând în secțiunea "Plăți".
`;
